function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default function Astrid({
  width,
  height,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 100 111"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#0F1650",
    d: "M85,108c-0.1,0-6.4-4.4-6.9-10.2c-0.3-2.9,1-5.8,3.8-8.5c0,0,0.1-0.1,0.1-0.1 c11.1-9.2,18.1-23,18.1-38.5c0-27.6-22.4-50-50-50s-50,22.4-50,50c0,27.6,22.4,50,50,50c2.3,0,4.5-0.2,6.7-0.5 c2.8,2.5,12.8,10.5,27.3,10.5c0.7,0,1.2-0.4,1.4-1.1C85.8,109.1,85.5,108.4,85,108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6FFF2",
    d: "M48.6,65.2c-8.6,0-15.6-7-15.6-15.6S40,34,48.6,34s15.6,7,15.6,15.6S57.2,65.2,48.6,65.2 M70.1,49.6c0-11.9-9.7-21.5-21.5-21.5S27,37.7,27,49.6c0,11.9,9.7,21.5,21.5,21.5c6.1,0,11.7-2.6,15.6-6.7v4.5 c0,1.6,1.3,3,3,3c1.6,0,3-1.3,3-3V49.9c0,0,0-0.1,0-0.1C70.1,49.7,70.1,49.7,70.1,49.6"
  }));
}
//# sourceMappingURL=index.js.map